import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-technologist",
  templateUrl: "./technologist.component.html",
})
export class TechnologistComponent implements OnInit {
  rowsData = [
    { title: "First Name", sorting: true, name: "firstName", underline: true },
    { title: "Last Name", sorting: true, name: "lastName", underline: true },
    { title: "Home Address", tooltip: true },
    { title: "Imaging Center" },
  ];

  columnsData = [];
  columnsRes = [];
  p = 1;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 10;
  firstNameControl = new FormControl();
  formCtrlSub: Subscription;
  searchPatient = "";
  sortColumn = "createdOn";
  orderColumn = "desc";
  searchText = "";
  alphaVal = "all";
  routerName = "";
  maxSizeItemValue: any;
  address: any = "";
  startDate = "";
  endDate = "";
  countryData = [];
  stateData = [];
  countryidadmin: any = "";
  stateidadmin: any = "";
  country: any = "";
  selectedCountry: any = "";
  selectedState: any = "";
  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private router: Router
  ) {}

  ngOnInit() {
    this.getAllCountry();

    if (
      sessionStorage.getItem("startDate") &&
      sessionStorage.getItem("endDate")
    ) {
      this.startDate = sessionStorage.getItem("startDate");
      this.endDate = sessionStorage.getItem("endDate");
    } else {
      this.startDate = "";
      this.endDate = "";
    }

    this.getAllTechniciansListAdmin("");

    this.supportService.gridSortingHeader.subscribe((res) => {
      if (res && res["length"] !== 0 && res["routerName"] === this.routerName) {
        this.sortColumn = res["name"];
        this.orderColumn = res["order"];
        const event = {
          page: 1,
        };
        this.currentPage = 1;
        this.getAllTechniciansListAdmin(event);
      }
    });
    this.checkUrl();
  }

  getAllCountry() {
    this.appService.getCountry().subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.countryData = res["entity"];
      } else {
        this.countryData = [];
      }
    });
  }

  getAllStateByCountry(countryid) {
    if (!countryid) { this.stateData = []; return; }
    this.appService.getState(countryid).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.stateData = res["entity"];
      } else {
        this.stateData = [];
      }
    });
  }

  onChangeState(event) {
    sessionStorage.setItem("stateidadmin", this.selectedState.id);
    this.stateidadmin = sessionStorage.getItem("stateidadmin");
    this.getAllTechniciansListAdmin("");
  }

  onChange(event) {
    if (!event || !event.id) { return; }
    sessionStorage.setItem("countryidadmin", this.selectedCountry.id);
    this.countryidadmin = sessionStorage.getItem("countryidadmin");
    this.stateidadmin = "";
    this.getAllStateByCountry(event.id);
    this.selectedState = "";
    this.getAllTechniciansListAdmin("");
  }

  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  onBlurSearchMethod() {
    this.searchPatient = this.searchText;
    this.currentPage = 1;
    this.getAllTechniciansListAdmin("");
  }

  refreshPatient() {
    this.searchText = "";
    this.searchPatient = "";
    this.selectedCountry = "";
    this.selectedState = "";
    this.stateidadmin = "";
    this.countryidadmin = "";
    this.getAllTechniciansListAdmin("");
  }

  alphaSearch(val) {
    if (val !== "all") {
      this.searchPatient = val;
    } else {
      this.searchPatient = "";
    }
    this.alphaVal = val;
    this.searchText = "";
    this.getAllTechniciansListAdmin("");
  }
  fromtechie = true;
  getAllTechniciansListAdmin(event) {
    let data;
    if (event) {
      data = {
        pageNumber: event.page,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        startDate: this.startDate,
        endDate: this.endDate,
        countryid: this.countryidadmin,
        stateid: this.stateidadmin,
      };
    } else {
      data = {
        pageNumber: 1,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        startDate: this.startDate,
        endDate: this.endDate,
        countryid: this.countryidadmin,
        stateid: this.stateidadmin,
      };
    }

    this.appService.getAllTechniciansListAdminWithFilter(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              if (obj.addressline1) {
                this.address += obj.addressline1 + ",";
              }
              if (obj.addressline2) {
                this.address += obj.addressline2 + ",";
              }
              if (obj.cityname) {
                this.address += obj.cityname + ",";
              }
              if (obj.statename) {
                this.address += obj.statename + ",";
              }
              if (obj.countryname) {
                this.address += obj.countryname;
              }

              this.columnsData = this.columnsData.concat({
                param1: obj.firstName ? obj.firstName : "-",
                param2: obj.lastName ? obj.lastName : "-",
                param3: this.address ? this.address : "-",
                param4: obj.testcentername ? obj.testcentername : "-",
                param5: this.routerName ? this.routerName : "-",
                param6: obj.id ? obj.id : "-",
                param13: "Double click for edit",
              });

              this.address = "";
            });
            this.totalItems = res["count"];
          }
        } else {
          this.columnsData = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  pageChanged(event: any): void {
    this.page = event.page;
    this.getAllTechniciansListAdmin(event);
  }

  navigateToDashboard() {
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "dashboard",
    ]);
  }
}
